export default "__VITE_ASSET__DlAXnyf8__"